@if (videos().length > 0) {
  <div class="videos-section">
    <h3 class="section-title">{{ "projectDetails.videos.title" | translate }}</h3>
    <div class="videos-row">
      @for (video of videos(); track video.id) {
        <button
          type="button"
          class="video-card"
          (click)="onDownloadVideo($event, video)"
          [attr.aria-label]="'Download ' + video.name"
        >
          <div class="video-thumbnail">
            <i class="fas fa-play-circle play-icon" aria-hidden="true"></i>
            <span class="video-name">{{ video.name }}</span>
          </div>
        </button>
      }
    </div>
  </div>
} @else {
  <div class="videos-section">
    <h3 class="section-title">{{ "projectDetails.videos.title" | translate }}</h3>
    <p class="no-content">{{ "projectDetails.videos.noVideos" | translate }}</p>
  </div>
}
